/**
 * Soft-safe Move 3: step panel barrel + renderStepPanel switch.
 * Soft-safe ③: Soft #2 order owned by Summary; blinds Next owned by shell+helpers.requestStep.
 */
import type { StepId } from '../../lib/types'
import { renderActions, resetActorCustomDetails } from './actions'
import { renderCards } from './cards'
import { renderPosition } from './position'
import { renderSetup } from './setup'
import { isSummaryCard } from '../../state'
import { renderSummary } from './summary'
import { renderSummaryCardView } from './summaryCard'

export { renderSetup } from './setup'
export { renderPosition } from './position'
export { renderCards } from './cards'
export { renderActions, renderLineStrip, resetActorCustomDetails } from './actions'
export { renderSummary } from './summary'
export {
  blindsError,
  explainModeToggle,
  go,
  languageSwitcher,
  requestStep,
  softHint,
} from './helpers'

export function renderStepPanel(step: StepId): HTMLElement {
  if (step !== 'actions') resetActorCustomDetails()
  switch (step) {
    case 'setup':
      return renderSetup()
    case 'position':
      return renderPosition()
    case 'cards':
      return renderCards()
    // Softwise M10b: legacy `board` step renders the Line (board asked inline).
    case 'board':
    case 'actions':
      return renderActions()
    case 'summary':
      // Soft I1b: input just finished → card + [되돌리기][공유] only.
      return isSummaryCard() ? renderSummaryCardView() : renderSummary()
  }
}
